import { httpCollection } from "us.helper/http/collection";

export default {
  creditorApproval: {
    getApprovalList: (params: string | number): Promise<any> => {
      return new Promise<any>(async (resolve, reject) => {
        try {
          const { data, status } = await httpCollection.get(
            "entityservice",
            "creditor/creditorcreationrequest",
            {}
          );

          resolve({
            data,
            status,
          });
        } catch (error) {
          reject(error);
        }
      });
    },

    addCreditorApproval: (params: any): Promise<any> => {
      return new Promise<{}>(async (resolve, reject) => {
        try {
          let pendingApprovalsList = {};
          const data = await httpCollection.post(
            "entityservice",
            "creditor/creditorcreationrequest/approve",
            params
          );
          if (data?.status === 201 || data?.status == 200) {
            pendingApprovalsList = await httpCollection.get(
              "entityservice",
              "creditor/creditorcreationrequest",
              {}
            );

            resolve({ data, pendingApprovalsList });
          } else {
            resolve({ data: data, pendingApprovalsList: {} });
          }
        } catch (error) {
          reject(error);
        }
      });
    },
  },
};
